/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_Step1Inputs */

const en_gc_resources_guide_start_step1 = /** @type {(inputs: Gc_Resources_Guide_Start_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the original workbook as a backup. In the browser workspace, use the file-open control and select a .xlsx file from your computer.`)
};

const zh_gc_resources_guide_start_step1 = /** @type {(inputs: Gc_Resources_Guide_Start_Step1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先备份原始工作簿。在浏览器工作空间使用打开文件的控件，选择电脑中的 .xlsx 文件。`)
};

/**
* | output |
* | --- |
* | "Keep the original workbook as a backup. In the browser workspace, use the file-open control and select a .xlsx file from your computer." |
*
* @param {Gc_Resources_Guide_Start_Step1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_step1 = /** @type {((inputs?: Gc_Resources_Guide_Start_Step1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_Step1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_step1(inputs)
	return zh_gc_resources_guide_start_step1(inputs)
});
export { gc_resources_guide_start_step1 as "gc.resources.guide.start.step1" }